import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import PublicLayout from 'v2/components/Shared/PublicLayout';
import PreviewCard from 'v2/components/Shared/SelectCreditCard/previewCard';

import type { ICard } from 'v2/components/Shared/SelectCreditCard';
import type { ISubscriptions } from 'v2/interfaces/subscriptions';

interface IProps {
  contract: ISubscriptions;
  card: ICard;
}

const AccountCreated = ({ contract, card }: IProps) => {
  return (
    <PublicLayout>
      <Grid container>
        <Grid item xs={12} direction='column'>
          <Card>
            <CardContent style={{ textAlign: 'center', padding: 30 }}>
              <Typography variant='subtitle1'>Forma de pagamento alterada com sucesso!</Typography>
              <Typography variant='subtitle2'>A forma de pagamento para o contrato {contract.id} foi alterado para:</Typography>
              <div className='m24' />
              <PreviewCard card={card} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </PublicLayout>
  );
};

export default AccountCreated;
